// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root layout — scoped so it does not override the main user login */
.affilate-login-page {
    min-height: 100vh;
    background: #0088cc;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 16px;
  }
  
  /* Logo above the card */
  .page-logo {
    width: 100px;
    margin-bottom: 20px;
  }
  
  /* Login card */
  .login-container {
    width: 100%;
    max-width: 400px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    padding: 30px 20px;
    box-sizing: border-box;
  }
  
  /* Form heading */
  .affilate-login-page .login-form h2 {
    margin-bottom: 20px;
    font-size: 24px;
    text-align: center;
    color: #333;
  }
  
  /* Inputs */
  .affilate-login-page .login-form input {
    width: 100%;
    padding: 12px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 6px;
    margin-bottom: 15px;
    box-sizing: border-box;
  }
  
  /* Button */
  .affilate-login-page .login-form button {
    width: 100%;
    padding: 12px;
    font-size: 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .affilate-login-page .login-form button:hover {
    background-color: #0056b3;
  }
  .error-message {
    color: #ff3333;
    background-color: #ffe6e6;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 15px;
    text-align: center;
  }
  
  /* Mobile tweaks */
  @media (max-width: 480px) {
    .affilate-login-page .login-form h2 {
      font-size: 20px;
    }
  
    .affilate-login-page .login-form input,
    .affilate-login-page .login-form button {
      font-size: 15px;
      padding: 10px;
    }
  
    .page-logo {
      width: 80px;
      margin-bottom: 15px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/affilate-app/pages/login/login.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA,wBAAwB;EACxB;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA,eAAe;EACf;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;;EAEA,WAAW;EACX;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA,WAAW;EACX;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE;MACE,eAAe;IACjB;;IAEA;;MAEE,eAAe;MACf,aAAa;IACf;;IAEA;MACE,WAAW;MACX,mBAAmB;IACrB;EACF","sourcesContent":["/* Root layout — scoped so it does not override the main user login */\n.affilate-login-page {\n    min-height: 100vh;\n    background: #0088cc;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 30px 16px;\n  }\n  \n  /* Logo above the card */\n  .page-logo {\n    width: 100px;\n    margin-bottom: 20px;\n  }\n  \n  /* Login card */\n  .login-container {\n    width: 100%;\n    max-width: 400px;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n    padding: 30px 20px;\n    box-sizing: border-box;\n  }\n  \n  /* Form heading */\n  .affilate-login-page .login-form h2 {\n    margin-bottom: 20px;\n    font-size: 24px;\n    text-align: center;\n    color: #333;\n  }\n  \n  /* Inputs */\n  .affilate-login-page .login-form input {\n    width: 100%;\n    padding: 12px;\n    font-size: 16px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    margin-bottom: 15px;\n    box-sizing: border-box;\n  }\n  \n  /* Button */\n  .affilate-login-page .login-form button {\n    width: 100%;\n    padding: 12px;\n    font-size: 16px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .affilate-login-page .login-form button:hover {\n    background-color: #0056b3;\n  }\n  .error-message {\n    color: #ff3333;\n    background-color: #ffe6e6;\n    padding: 10px;\n    border-radius: 4px;\n    margin-bottom: 15px;\n    text-align: center;\n  }\n  \n  /* Mobile tweaks */\n  @media (max-width: 480px) {\n    .affilate-login-page .login-form h2 {\n      font-size: 20px;\n    }\n  \n    .affilate-login-page .login-form input,\n    .affilate-login-page .login-form button {\n      font-size: 15px;\n      padding: 10px;\n    }\n  \n    .page-logo {\n      width: 80px;\n      margin-bottom: 15px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
